

(function($, App, Utils){
  'use strict';

  var logger = new Logger("RadioDeselect");

  Utils.add('RadioDeselect', {

    bindEvents: function() {

      $('input[type="radio"]').off('click').on('click', function(){
          // Processing only those that match the name attribute of the currently clicked button...
          // Every member of the current radio group except the clicked one...
        $('input[name="' + $(this).attr('name') + '"]').not( $(this) ).trigger('deselect');
      });
    },

    init: function() {
      this.bindEvents();
    }

  });

})(jQuery, window.App, window.App.Utils);
